export default __webpack_public_path__ + "2db794eead2ebffb7f7cf9e0cfef9fe4.svg";